import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Card from 'cityads-v3/components/Card/Card';
import ContactForm from './ContactForm';

import classes from './ContactFormCard.scss';

type ContactFormCardProps = {
  className?: string
}

export default function ContactFormCard({ className }: ContactFormCardProps): JSX.Element {
  const { t } = useTranslation(['main'])
  return (
    <Card
      className={classNames(classes.contactCard, className)}
      title={<h2 className={classes.cardHeaderTitle}>{t('contactFormCard.title')}</h2>}
      subtitle={t('contactFormCard.subtitle')}
      cardHeaderClasses={{
        root: classes.contactHeader,
        title: classes.contactTitle,
        subheader: classes.contactSubtitle,
      }}
    >
      <ContactForm
        className={classes.contactForm}
      />
    </Card>
  )
}
